import vi_VN from 'antd/es/locale/vi_VN';

vi_VN.Calendar.lang.placeholder = 'Chọn thời gian';

export default vi_VN;
